/**
 * « Journal des avoirs fournisseur » (/avoirs, /avoirs/:id) — screen CONFIG (design/ux/03 §2, §6.2;
 * refonte WP-30). Platform-governed UI values only: the business bounds (page sizes, sort whitelist,
 * search length, multi-value cap, cancellation roles) are the shared twin
 * `@pharmakon/shared/constants/avoirs.js`, checked against the server CONFIG by
 * `apps/server/src/__tests__/avoirs.parity.test.js` — never retyped here (PK-BUG-15).
 */
import {
  AVOIR_JOURNAL,
  ETAT_AVOIR,
  RAPPROCHEMENT_NOTE,
  TYPE_AVOIR,
  TYPE_NOTE_DE_CREDIT,
} from "@pharmakon/shared/constants/avoirs.js";
import { IMPRESSION_LIGNES_MAX } from "@/config/achat-journal.config.js";

export { AVOIR_JOURNAL };

/** The two tabs of §2.1 (`?tab=`). */
export const ONGLET_AVOIRS = Object.freeze({ PHARMACIE: "pharmacie", NOTES: "notes" });

/** §2.3 — the état chips, in their reading order (« Tous » is the chip group's own). */
export const ORDRE_ETATS_AVOIR = Object.freeze([
  ETAT_AVOIR.EN_ATTENTE,
  ETAT_AVOIR.REGLE_PARTIELLEMENT,
  ETAT_AVOIR.REGLE,
  ETAT_AVOIR.ANNULE,
]);

/** §2.7 — the matching chips of the connected fournisseurs' tab. */
export const ORDRE_RAPPROCHEMENT = Object.freeze([RAPPROCHEMENT_NOTE.A_RAPPROCHER, RAPPROCHEMENT_NOTE.RAPPROCHE]);

/** §2.3 — « Type » filter values, in the order of the editor's radio group (ux/03 §1.4). */
export const ORDRE_TYPES_AVOIR = Object.freeze([TYPE_AVOIR.ECART, TYPE_AVOIR.PRODUITS, TYPE_AVOIR.FINANCIER]);

/** §2.3 — « Période » presets and the default of a journal opened without any filter. */
export const PRESETS_PERIODE_AVOIRS = Object.freeze([
  { id: "ce_mois", label: "Ce mois" },
  { id: "mois_precedent", label: "Mois dernier" },
  { id: "ce_trimestre", label: "Ce trimestre" },
  { id: "cette_annee", label: "Cette année" },
]);
export const PERIODE_DEFAUT_AVOIRS = "ce_trimestre";

/** The URL keys of the journal (filters are `useFilters`'; these are the page's own). */
export const PARAMS_JOURNAL_AVOIRS = Object.freeze({ ONGLET: "tab", ETAT: "etat", RAPPROCHEMENT: "rapprochement", PAGE: "page" });

/** The default sort of the grid (server whitelist `AVOIR_JOURNAL.tris`). */
export const TRI_DEFAUT_AVOIRS = Object.freeze({ by: "date_avoir", order: "desc" });

/**
 * ux/03 §2.2 — below this content width (1024 layout: 904 px) the état chips use their short labels
 * and the footer its compact sentence; « Réf. fourn. » is the grid's priority-2 column (hidden by the
 * DataGrid under the same 1000 px container width, ux/01 §5.3).
 */
export const LARGEUR_COMPACTE_AVOIRS = 1000;

/**
 * §6.2 print — avoirs read for one printed journal (pages of `AVOIR_JOURNAL.limit_max`): the same
 * browser-print bound as the purchase journals (WP-52), beyond which the print says so and points to
 * the CSV export.
 */
export const IMPRESSION_AVOIRS_MAX = IMPRESSION_LIGNES_MAX;

/**
 * §2.7 « Créer l'avoir correspondant » — the pharmacy avoir type a connected fournisseur's credit
 * note opens the editor with (OP-03-11). A credit on the account or a refund of an e-facture reduce
 * what the pharmacy owes on it → « Crédit fournisseur » (refonte WP-81); a replacement of goods → « Produits ».
 * « défaut appliqué — à valider par le propriétaire » (A-57).
 */
export const TYPE_AVOIR_POUR_NOTE = Object.freeze({
  [TYPE_NOTE_DE_CREDIT.AVOIR_CREDIT]: TYPE_AVOIR.ECART,
  [TYPE_NOTE_DE_CREDIT.REMBOURSEMENT]: TYPE_AVOIR.ECART,
  [TYPE_NOTE_DE_CREDIT.REMPLACEMENT]: TYPE_AVOIR.PRODUITS,
});
